module.exports = __webpack_public_path__ + "img/mexican-picadillo.638a5736.jpg";